<template>
  <div class="setPassword pointer">
    <div class="AochenTop">
      <div class="top">
        <div class="fanhui" @click="getBack()" v-if="!skip">
          <img class="img1" src="@/assets/icons/fanhui.png" alt="" />
        </div>
        <div class="title">
          <p>{{ title }}</p>
        </div>
        <button class="title_btn" @click="getRegWelfare" v-if="skip">
          跳过
        </button>
      </div>
    </div>
    <!-- <NavBar :title="title" /> -->
    <div class="main">
      <div>
        <div class="phoneName">已绑定手机号：{{ phone }}</div>
        <div class="yanzhengma">
          <span class="inputBoxName">短信验证码</span>
          <van-cell-group :class="['inputBox']">
            <van-field
              class="inputBack"
              v-model="yanzhengma"
              placeholder="请输入验证码"
              maxlength="6"
            >
              <template #button>
                <van-button
                  v-if="!yzm_daojishi"
                  size="small"
                  class="yzm_btn"
                  @click="getyanzhengma"
                  >获取验证码</van-button
                >
                <van-button v-else size="small" class="yzm_btn" :disabled="true"
                  >重新发送（{{ countDown }}）</van-button
                >
              </template>
            </van-field>
          </van-cell-group>
        </div>
        <div class="yanzhengma">
          <span class="inputBoxName">密码</span>
          <van-cell-group :class="['inputBox']">
            <van-field
              class="inputBack"
              v-model="password"
              :type="showornot"
              name="密码"
              placeholder="请输入密码"
              :rules="[{ required: true, message: '请填写密码' }]"
            >
              <template #button>
                <span @click="isShow">
                  <van-icon name="closed-eye" v-if="showeye" />
                  <van-icon name="eye-o" v-else />
                </span>
              </template>
            </van-field>
          </van-cell-group>
          <van-cell-group :class="['inputBox']">
            <van-field
              class="inputBack"
              v-model="twicePassword"
              :type="showornot"
              name="密码"
              placeholder="请再次输入密码"
              :rules="[{ required: true, message: '请填写密码' }]"
            >
              <template #button>
                <span @click="isShow">
                  <van-icon name="closed-eye" v-if="showeye" />
                  <van-icon name="eye-o" v-else />
                </span>
              </template>
            </van-field>
          </van-cell-group>
          <div class="require">密码必须为数字+字母组合，长度6-12位</div>
        </div>
      </div>
      <van-button
        type="info"
        class="fsyzm_btn"
        :disabled="
          yanzhengma != '' && password != '' && twicePassword != ''
            ? false
            : true
        "
        :color="
          yanzhengma != '' && password != '' && twicePassword != ''
            ? ''
            : '#B2B4BA'
        "
        @click="chongzhipassword"
        >提交</van-button
      >
    </div>
  </div>
</template>
  
  <script>
import { Toast } from "vant";
import NavBar from "@/components/NavBar.vue";
import { getsendCode, modifypassword, resetpassword } from "@/api/login";
import { removeToken, removeData } from "@/utils/auth";
import { mapState, mapMutations } from "vuex";
export default {
  name: "SetPassword",
  components: {
    NavBar,
  },
  data() {
    return {
      phone: "",
      yanzhengma: "",
      password: "",
      twicePassword: "",
      jiaodian: false,
      jiaodians: false,
      yzm_daojishi: false,
      countDown: 60, // 倒计时时间
      timer: null, // 定时器
      showeye: true,
      showornot: "password",
      Switchlogin: true,
      title: "",
      skip: 0,
    };
  },

  mounted() {
    this.phone = this.$route.query.phone;
    this.title = this.$route.query.title;
    this.skip = this.$route.query.skip || 0;
    if (this.title == "重置密码") {
      this.startCountDown();
    }
    // this.getyanzhengma();
  },

  methods: {
    ...mapMutations("user", ["SET_TOKEN", "SET_DATA"]),
    // 回退
    getBack() {
      this.$router.go(-1);
    },
    // 获取验证码
    async getyanzhengma() {
      const phoneReg = /^1[3456789]\d{9}$/;
      if (!phoneReg.test(this.phone)) {
        Toast("手机号错误！请重新输入");
      } else {
        let data = {
          mobile: this.phone,
          businessType: "passwordLogin",
        };
        await getsendCode(data).then((res) => {
          if (res.code == 200) {
            this.startCountDown();
            Toast("验证码已发送至您的手机");
          }
        });
      }
    },
    // 设置修改密码
    async chongzhipassword() {
      if (this.password.length < 6) {
        Toast("密码长度最少为6位,请检查后重新输入！");
        return;
      }
      if (this.password != this.twicePassword) {
        Toast("两次输入的密码不一致，请检查后重新输入！");
        return;
      }
      let data = {
        password: this.password,
        phoneNumber: this.phone,
        code: this.yanzhengma,
        type:
          this.title == "重置密码"
            ? null
            : this.title == "设置密码"
            ? "1"
            : "2",
      };
      if (this.title == "重置密码") {
        resetpassword(data).then((res) => {
          if (res.code == 200) {
            Toast(`${this.title}成功，请重新登录!`);
            removeToken();
            removeData();
            this.SET_TOKEN(null);
            this.SET_DATA(null);
            this.$router.push("/login");
          }
        });
      } else if (this.title == "设置密码") {
        modifypassword(data).then((res) => {
          if (res.code == 200) {
            Toast(`${this.title}成功`);
            if (!this.skip) {
              this.$router.go(-1);
            }else{
              this.getRegWelfare()
            }
          }
        });
      } else {
        // 修改密码
        modifypassword(data).then((res) => {
          if (res.code == 200) {
            Toast(`${this.title}成功，请重新登录!`);
            removeToken();
            removeData();
            this.SET_TOKEN(null);
            this.SET_DATA(null);
            this.$router.push("/login");
          }
        });
      }
    },
    // 验证码倒计时
    startCountDown() {
      this.yzm_daojishi = true;
      this.timer = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--;
        } else {
          clearInterval(this.timer);
          this.yzm_daojishi = false;
          this.countDown = 60;
        }
      }, 1000);
    },
    //密码可见
    isShow() {
      //点击切换眼睛
      this.showeye = !this.showeye;
      if (this.showeye === true) {
        this.showornot = "password";
      } else {
        this.showornot = "text";
      }
    },
    getRegWelfare() {
      this.$router.push({
        name: "home",
      });
    },
  },
};
</script>
  
  <style lang="less" scoped>
.AochenTop {
  max-width: 414px;
  top: 0;
  // left: 0;
  width: 100%;
  height: 50px;
  z-index: 1001;
  font-size: 12px;
}
.top {
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  .fanhui {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      //   margin-top: 13px;
      //   width: 17px;
      height: 17px;
    }
    .img1 {
      width: 17px;
    }
  }
  .title {
    flex: 1;
    p {
      // margin-top: 30px;
      font-size: 16px;
      font-weight: 500;
    }
  }
  .title_btn {
    font-size: 15px;
    font-weight: 400;
    color: #886df3;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    // width: 58px;
    border: none;
    background: none;
  }
}
.setPassword {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.main {
  padding: 12px 18px 30px 18px;
  text-align: left;
  background: #fff;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .phoneName {
    color: #333;
    font-size: 16px;
    font-weight: 700;
  }
  .yanzhengma {
    // height: 72px;
    font-size: 16px;
    margin-top: 16px;
    .yzm_btn {
      border: none;
      background: #f4f4f4;
      font-size: 14px;
      color: #886df3;
    }
    /deep/.van-field__body {
      height: 33px;
    }
    .inputBoxName {
      color: #333;
      font-size: 16px;
      font-weight: 700;
    }
    .inputBox {
      background-color: #f4f4f4;
      border-radius: 79px;
      overflow: hidden;
      margin-top: 10px;
      height: 48px;
      display: flex;
      align-items: center;
      .inputBack {
        background-color: #f4f4f4;
      }
    }
    .require {
      color: #ccc;
      font-size: 12px;
      margin-top: 5px;
    }
  }
  /deep/ .van-hairline--top-bottom::after {
    border: none;
  }
  .fsyzm_btn {
    width: 100%;
    border: none;
    height: 44px;
    font-size: 16px;
    margin-top: 20px;
    font-weight: 500;
    color: #ffffff;
    background: #886df3;
    border-radius: 40px;
  }
}
</style>